/**
 * CMS Feature flag key for the consolidated 2026 revamp: one switch for the
 * category-pages browse revamp, the detail-page revamps, view transitions,
 * the auth and subscribe modals and the rest of the beta surface.
 *
 * Shared by the client hook (useCategoryRevamp) and the server gate
 * (isCategoryRevampActive) so the key lives in one place.
 */
export const REVAMP_FEATURE_KEY = 'revamp_2026';
